import * as React from 'react';
import { InputFeedback } from './InputFeedback';
import { InputLabel } from './InputLabel';

// #region Component Props

interface IProps {
    id              : string;
    label           : string;
    value           : any;
    onChange        : any;
    className?      : string;
    error?          : string;
    disable?        : boolean;
    isOptional?     : boolean;
    defaultLines?   : number;
    allowReturn?    : boolean;
}

// #endregion

const TextArea : React.SFC<IProps> = (props) => {

    const { 
        className, 
        id, 
        error, 
        label, 
        value, 
        onChange, 
        disable,
        allowReturn 
    } = props;

    return (
        <div className={'form-group ' + (className)}>
            <InputLabel htmlFor={id} error={error}>
                {label}
            </InputLabel>
            <textarea
                id={id}
                className="form-control"
                style={ props.defaultLines ? { height: `${props.defaultLines * 2.2}rem` } : {} }
                disabled={disable}
                value={value}
                onKeyDown={ (e) => { if (e.key === 'Enter' && allowReturn === false ) { e.preventDefault(); } }}
                onChange={onChange}
            />
            <InputFeedback error={error} />
        </div>
    );
};

TextArea.defaultProps = {
    className   : '',
    error       : '',
    disable     : false,
    isOptional  : false,
    allowReturn : false
};

export { TextArea };
